import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const RECLAMATION_OUTER_REASON_URL = 'reclamation/outer-reasons'

const errors = createHandbookResponseErrors('причину внешней рекламации', 'причин внешней рекламации')

export const ReclamationOuterReasonApi = createNewHandbookApi(RECLAMATION_OUTER_REASON_URL, errors)
